import React from 'react'
import Icon from './Icon'

class DownloadCircled extends React.Component {
  render () {
    return (
      <Icon {...this.props}>
        <svg
          width='20px'
          height='20px'
          viewBox='0 0 24 24'
          className={this.props.className || 'icon icon--tooltip icon-info'}
        >
          <g stroke='none' strokeWidth='1' fill='none'>
            <g transform='translate(-213.000000, -268.000000)' fill='#7E8DA2'>
              <path d='M225,290.5 C219.201,290.5 214.5,285.7975 214.5,280 C214.5,274.2025 219.201,269.5 225,269.5 C230.799,269.5 235.5,274.2025 235.5,280 C235.5,285.7975 230.799,290.5 225,290.5 L225,290.5 Z M225,268 C218.37225,268 213,273.37 213,280 C213,286.63 218.37225,292 225,292 C231.62775,292 237,286.63 237,280 C237,273.37 231.62775,268 225,268 L225,268 Z M228.84075,279.595 L225.75,282.6925 L225.75,274.75 C225.75,274.3375 225.41475,274 225,274 C224.586,274 224.25,274.3375 224.25,274.75 L224.25,282.6925 L221.15925,279.595 C220.866,279.3025 220.39125,279.3025 220.09875,279.595 C219.8055,279.895 219.8055,280.3675 220.09875,280.66 L224.34075,284.905 C224.52075,285.085 224.76675,285.1375 225,285.0925 C225.23325,285.1375 225.47925,285.085 225.65925,284.905 L229.90125,280.66 C230.1945,280.3675 230.1945,279.895 229.90125,279.595 C229.6095,279.3025 229.134,279.3025 228.84075,279.595 L228.84075,279.595 Z' />
            </g>
          </g>
        </svg>
      </Icon>
    )
  }
}

export default DownloadCircled
